module.exports = __webpack_public_path__ + "static/media/icon_hazard_grey.7922afd6.svg";